
import { Injectable, OnInit, Injector } from '@angular/core';
import { ParserService } from '../ws/ws.service';
import { IMediaParser } from './media-parser';
import { IMediaManager } from './media-manager';
import { WsService2 } from '../ws/ws.service';


declare var LZString;

@Injectable()
export class MediaParserService extends ParserService implements IMediaParser {
    constructor(ws: WsService2) {
        super(ws);
    }
    sendStat(media, audioPacketsLost, videoPacketsLost, bw, bwAudio, bwVideo){
        this.send("stat", {audioPacketsLost: audioPacketsLost,videoPacketsLost: videoPacketsLost, media: media, bw: bw, bwAudio: bwAudio, bwVideo:bwVideo });
    }
    setManager(r: IMediaManager) {
        this.manager = r;
    }
    manager: IMediaManager
    testConnectivity(media){
        this.send("testConnectivity", {media: media});
    }
    sendSnapshot(snapshot){
       
        this.send("snapshot", {media: snapshot});
    }
    parseMessage(m) {
      //  if (this.wbService.isDemo()) return;
        console.log('parsing message', m.cmd)
        switch (m.cmd) {
            case "requestMedia": this.onRequestMedia(m); break;
            case "handshake": this.onHandshake(m); break;
            case "candidate": this.onCandidate(m); break;
            case "connected": this.onConnectedMedia(m); break;
            case "exited": this.onExited(m); break;
            case "incomingUpdated": this.incomingUpdated(m); break;
            case "alreadyConnected": this.alreadyConnected(m); break;
            case "mediaReconnected": this.mediaReconnected(m); break;
            case "noMoreStreams": this.noMoreStreams(m); break;
            
        }
    }

    noMoreStreams(m) {
        console.log("Got no more streams");
        this.manager.noMoreStreams();
    }
    mediaReconnected(m) {
        this.manager.mediaReconnected()
    }
    alreadyConnected(m) {
        this.manager.alreadyConnected(m.callee, m.media);
    }
    incomingUpdated(m) {
        this.manager.onIncomingUpdated(m.callee, m.media);
    }
    requestChangeMedia(callee, media) {
       // if (this.wbService.isDemo()) return;
        this.send("changeMedia", { callee: callee, media: media });
    }
    onRequestMedia(m) {
        this.manager.onRequestMedia(m.callee, m.media, m.outgoing);
    }
    onHandshake(m) {
        this.manager.onHandshake(m.callee, m.media, m.sdp);
    }
    onCandidate(m) {
        this.manager.onCandidate(m.callee, m.media, JSON.parse(m.candidate));
    }
    onConnectedMedia(m) {
        this.manager.onConnected(m.media, m.callee);
    }
    onExited(m) {
        this.manager.onExited(m.who);
    }
    sendHandshake(sdp, outgoing, callee, media) {
        this.send("handshake", { sdp: sdp, outgoing: outgoing, callee: callee, media: media });
    }
    sendPcDown(callee, media) {
        this.send("pcDown", { callee: callee, media: media });
    }
    sendCandidate(callee, media, candidate) {
        this.send("candidate", { callee: callee, media: media, candidate: candidate });
    }
    onDisconnected() {
        this.manager.onDisconnected();
    }
    sendClosed(who) {
        this.send("gotClosed", { callee: who });
    }

}



// WEBPACK FOOTER //
// /app/src/app/wb/services/media/media-parser.service.ts